import { render } from "./TotalMentors.vue?vue&type=template&id=2a830098&ts=true"
import script from "./TotalMentors.vue?vue&type=script&lang=ts"
export * from "./TotalMentors.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__